export default __webpack_public_path__ + "static/media/checkin.4a048fc9.svg";